/*
 * @Author: xzj
 * @Date: 2021-05-07 09:49:44
 * @Description: 所有的api接口归到这里，统一管理
 *
 * 接口管理规范：
 * 1、所有的接口写在一个对象中导出；
 * 2、每一个接口控制两个变量，请求方法和url地址；
 * 3、同模块不同功能之间空一行，注释跟在行后,不同功能模块之间用单独一行的注释隔开，且注释中用---拉长；
 * 4、接口名称全部使用大写字母，多个单词之间用下划线连接；
 * 5、接口名字的命名规则以后台的react规范的方式命名，如：list，retrieve，create...
 * 6、放弃put方法，全面使用patch方法来update后台数据；
 *
 */
import http from "../utils/request.js";

export default {
  // 登录
  LOGIN: (params) => http.post("/login/", params),
  LOGIN_AND_AUTH: (name, password) =>
    http.get(`/user/loginAndAuth?name=${name}&password=${password}`),
  LOGOUT: () => http.post("/user/logout"),

  // 上传token
  UPLOAD_TOKEN: () => http.get("/token/upload"),

  // 曲谱
  SONG_SEARCH: (params) => http.get("/song/platformSearch", { params }),
  SONG_InsertOrUpdate: (params) => http.post("/song/insertOrUpdate", params),
  SONG_DETAIL: (params) => {
    return http.get(`/song`, params);
  },
  SONG_PUBLISH: (songId) => {
    return http.post(`/song/publish?songId=${songId}`);
  },
  SONG_UN_PUBLISH: (songId, unPublishStatus) => {
    return http.post(
      `/song/unPublish?songId=${songId}&unPublishStatus=${unPublishStatus}`
    );
  },
  SONG_DELETE: (songId) => http.post(`/song/delete?songId=${songId}`),
  SONG_OF_CATEGORY: (params) => {
    return http.get(`/song/allSongOfCategory`, { params });
  },
  SONG_SEARCH_NO_PAGE: (songId, keyWord, status) => {
    return http.get(
      `/song/platformSearchNoPage?songId=${songId}&keyWord=${keyWord}&status=${status}`
    );
  },
  SONG_MUTI_IMPORT: (params) => http.post("/song/mutiImportSongs", params),
  SONG_OF_TAG: (tagId) => {
    return http.get(`/song/allSongOfTag?tagId=${tagId}`);
  },
  SONG_BELONG: (pUserId) => {
    return http.get(`/song/belong?pUserId=${pUserId}`);
  },

  //曲谱错误
  SONG_ERROR_SEARCH: (data) => http.post("/songError/platformSearch", data),
  SONG_ERROR_READED: (id) => http.post(`/songError/readed?id=${id}`),
  SONG_ERROR_RESOLVED: (id) => http.post(`/songError/resolved?id=${id}`),
  SONG_ERROR_REJECT: (id) => http.post(`/songError/reject?id=${id}`),

  // 曲谱分类
  SONG_CATEGORY_LIST: () => http.get(`/song/category`),
  SONG_CATEGORY_MUTISAVE: (params) =>
    http.post("/song/multiSaveCategory", params),

  // 乐器选项
  MUSICAL_INSTRUMENT_LIST: (params) =>
    http.get("/instrument/getAll", { params }),
  MUSICAL_INSTRUMENT_CREATE: (params) =>
    http.get("/musical-instrument/", { params }),
  MUSICAL_INSTRUMENT_DELETE: (pk) => http.get(`/musical-instrument/${pk}/`),

  //音乐标签
  TAG_MUSIC_TREE: () => http.get("/tagMusic/getTree"),
  TAG_MUSIC_ADD: (params) => http.post("/tagMusic/add", params),
  TAG_MUSIC_UPDATE: (params) => http.post("/tagMusic/update", params),
  TAG_MUSIC_DELETE: (id) => http.post(`/tagMusic/delete?id=${id}`),
  TAG_MUTISAVE: (params) => http.post("/song/multiSaveTag", params),

  // 拨片节奏型
  PICK_SEARCH: (params) => http.post("/rhythmic/pick/platformSearch", params),
  PICK_CATEGORY_TREE: () => http.get("/rhythmic/pickCategory/getTree"),
  RHYTHMIC_PICK_CATEGORY_LIST: (params) =>
    http.get("/rhythmic/pick/getTree", { params }),
  RHYTHMIC_PICK_INSERT_OR_UPDATE: (params) =>
    http.post("/rhythmic/pick/insertOrUpdate", params),
  RHYTHMIC_PICK_PUBLISH: (pickId) =>
    http.post(`/rhythmic/pick/publish?pickId=${pickId}`),
  RHYTHMIC_PICK_OFFSHELF: (pickId) =>
    http.post(`/rhythmic/pick/offShelf?pickId=${pickId}`),
  RHYTHMIC_PICK_DELETE: (pickId) =>
    http.post(`/rhythmic/pick/delete?pickId=${pickId}`),

  // 鼓机
  DRUM_LIST: (params) => http.get("/rhythmic/drum/getAll", { params }),
  DRUM_SEARCH: (params) => http.post("/rhythmic/drum/platformSearch", params),
  DRUM_CATEGORY_LIST: () => http.get("/rhythmic/drum/getCategory"),
  DRUM_INSERT_OR_UPDATE: (params) =>
    http.post("/rhythmic/drum/insertOrUpdate", params),
  DRUM_PUBLISH: (drumId) =>
    http.post(`/rhythmic/drum/publish?drumId=${drumId}`),
  DRUM_OFFSHELF: (drumId) =>
    http.post(`/rhythmic/drum/offShelf?drumId=${drumId}`),
  DRUM_DELETE: (drumId) => http.post(`/rhythmic/drum/delete?drumId=${drumId}`),

  //教学视频
  TUTORIAL_SEARCH: (params) => http.post("/tutorial/platformSearch", params),
  TUTORIAL_CATEGORY_LIST: () => http.get("/tutorial/getCategory"),
  TUTORIAL_INSERT_OR_UPDATE: (params) =>
    http.post("/tutorial/insertOrUpdate", params),
  TUTORIAL_PUBLISH: (id) => http.post(`/tutorial/publish?tutorialId=${id}`),
  TUTORIAL_OFFSHELF: (id) => http.post(`/tutorial/offShelf?tutorialId=${id}`),
  TUTORIAL_DELETE: (id) => http.post(`/tutorial/delete?tutorialId=${id}`),

  //App版本
  VERSION_SEARCH: (params) => http.post("/version/platformSearch", params),
  VERSION_INSERT_OR_UPDATE: (params) =>
    http.post("/version/insertOrUpdate", params),
  VERSION_PUBLISH: (id) => http.post(`/version/publish?versionId=${id}`),
  VERSION_OFFSHELF: (id) => http.post(`/version/offShelf?versionId=${id}`),
  VERSION_DELETE: (id) => http.post(`/version/delete?versionId=${id}`),

  //设备固件
  VERSION_DEVICE_SEARCH: (params) =>
    http.post("/versionDevice/platformSearch", params),
  VERSION_DEVICE_INSERT_OR_UPDATE: (params) =>
    http.post("/versionDevice/insertOrUpdate", params),
  VERSION_DEVICE_PUBLISH: (id) => http.post(`/versionDevice/publish?id=${id}`),
  VERSION_DEVICE_OFFSHELF: (id) =>
    http.post(`/versionDevice/offShelf?id=${id}`),
  VERSION_DEVICE_DELETE: (id) => http.post(`/versionDevice/delete?id=${id}`),
  VERSION_DEVICE_INVITE_ADD: (params) =>
    http.post("/grayUser/addInvite", params),
  VERSION_DEVICE_INVITE_IMPORT: (formData, versionDeviceId) =>
    http.post(`/grayUser/batchImport?versionDeviceId=${versionDeviceId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  VERSION_DEVICE_INVITE_SEARCH: (params) =>
    http.post("/grayUser/inviteList", params),
  VERSION_DEVICE_INVITE_REMOVE: (params) =>
    http.post("/grayUser/removeInvite", params),
  VERSION_DEVICE_GRAY_USER_SEARCH: (params) =>
    http.post("/grayUser/grayUserList", params),

  //用户
  USER_SEARCH: (params) => http.post("/user/platformSearch", params),
  USER_EXTERNAL: (userId) =>
    http.get(`/thirdExternal/getByUserId?userId=${userId}`),
  USER_DEVICEVO: (userId) =>
    http.get(`/device/getUserPDeviceVo?userId=${userId}`),
  USER_PLAYLOG: (params) => http.get("/playLog/platformSearch", { params }),
  USER_CUSTOMSONG: (params) => http.post("/customSong/platformSearch", params),
  USER_ACCESSTOKEN: (params) =>
    http.get("/accessToken/platformSearch", { params }),
  USER_UPDATE: (params) => http.post("/user/updateUserInfo", params),
  USER_UPDATE_REMARK: (params) => http.post("/user/updateRemark", params),

  //马甲用户
  PRETEND_USER_SEARCH: (params) =>
    http.post("/pretendUser/platformSearch", params),

  //白名单
  WHITE_SEARCH: (params) =>
    http.get("/whiteBlack/whitePlatformSearch", { params }),
  WHITE_INSERT: (params) =>
    http.post(
      `/whiteBlack/insertOrUpdate?id=${params.id ?? ""}&mobile=${params.mobile
      }&remark=${params.remark}&pUserId=${params.pUserId}&type=${params.type}`
    ),
  WHITE_REMOVE: (id) =>
    // http.post(`/whiteBlack/removeWhite?mobile=${mobile}`),
    http.post(`/whiteBlack/delete?id=${id}`),

  WHITE_TYPE: () => http.get(`/whiteBlack/getType`),

  //通用配置
  COMMON_SETTING_SEARCH: (params) =>
    http.post("/sysCommonSetting/platformSearch", params),
  COMMON_SETTING_INSERT_OR_UPDATE: (params) =>
    http.post("/sysCommonSetting/insertOrUpdate", params),
  COMMON_SETTING_PUBLISH: (id) =>
    http.post(`/sysCommonSetting/publish?id=${id}`),
  COMMON_SETTING_OFFSHELF: (id) =>
    http.post(`/sysCommonSetting/unPublish?id=${id}`),
  COMMON_SETTING_DELETE: (id) => http.post(`/sysCommonSetting/delete?id=${id}`),
  COMMON_SETTING_DETAIL: (id) => http.get(`/sysCommonSetting/detail?id=${id}`),

  // appError报错
  APPERROR_SEARCH: (params) => http.get("/appError/platformSearch", { params }),
  APPERROR_DETAIL: (id) => http.get(`/appError/getById?id=${id}`),

  // appWrong系统优化
  APPWRONG_SEARCH: (params) => http.post("/appWrong/platformSearch", params),
  APPWRONG_READED: (id, pUserId) =>
    http.post(`/appWrong/readed?id=${id}&pUserId=${pUserId}`),
  APPWRONG_RESOLVED: (id, pUserId) =>
    http.post(`/appWrong/resolved?id=${id}&pUserId=${pUserId}`),
  APPWRONG_REJECT: (id, pUserId) =>
    http.post(`/appWrong/reject?id=${id}&pUserId=${pUserId}`),
  APPWRONG_REMARK: (id, remark) =>
    http.post(`/appWrong/updateRemark?id=${id}&remark=${remark}`),

  // 设备
  DEVICE_SEARCH: (params) => http.get("/device/platformSearch", { params }),
  DEVICE_UNBIND: (params) => http.get("/device/unbind", { params }),

  //七牛云获取token
  QINIU_GET_TOKEN: (params) => http.get("/qiniu/getToken", { params }),

  //渠道
  CLIENT_GETALL: () => http.get("/client/getAll"),

  //看板
  BOARD_STATISTICS1: () => http.get("/board/statistics1"),
  BOARD_PIE2: () => http.get("/board/pie2"),
  BOARD_STATISTICS2: (params) => http.get("/board/statistics2", { params }),
  BOARD_STATISTICS3: (params) => http.get("/board/statistics3", { params }),
  BOARD_STATISTICS4: (params) => http.get("/board/statistics4", { params }),
  BOARD_STATISTICS5: (params) => http.post("/board/statistics5", params),
  BOARD_STATISTICS6: (params) => http.get("/board/statistics6", { params }),
  BOARD_STATISTICS7: (params) => http.get("/board/statistics7", { params }),
  BOARD_STATISTICS8: (params) => http.get("/board/statistics8", { params }),
  // BOARD_STATISTICS5: (params) => http.get('/board/statistics5', { params }),
  BOARD_RECORDOLDESTDATE: () => http.get("/board/getRecordOldestDate"),
  BOARD_STATISTICS9: (params) => http.get("/board/statistics9", { params }),

  //tipoff
  TIPOFF_SEARCH: (params) => http.post("/tipOff/platformSearch", params),
  TIPOFF_READED: (id, pUserId) =>
    http.post(`/tipOff/readed?id=${id}&pUserId=${pUserId}`),
  TIPOFF_HANDLING: (id, pUserId) =>
    http.post(`/tipOff/handling?id=${id}&pUserId=${pUserId}`),
  TIPOFF_HANDLED: (id, pUserId) =>
    http.post(`/tipOff/handled?id=${id}&pUserId=${pUserId}`),
  TIPOFF_REJECT: (id, pUserId) =>
    http.post(`/tipOff/reject?id=${id}&pUserId=${pUserId}`),
  TIPOFF_REMARK: (id, remark) =>
    http.post(`/tipOff/updateRemark?id=${id}&remark=${remark}`),

  //官方公告
  NOTICE_SEARCH: (params) => http.post("/notice/platformSearch", params),
  NOTICE_DETAIL: (id) => http.get(`/notice/platformDetail?noticeId=${id}`),
  NOTICE_INSERT_OR_UPDATE: (params) =>
    http.post("/notice/insertOrUpdate", params),
  NOTICE_PUBLISH: (id) => http.post(`/notice/publish?id=${id}`),
  NOTICE_OFFSHELF: (id) => http.post(`/notice/unPublish?id=${id}`),
  NOTICE_DELETE: (id) => http.post(`/notice/delete?id=${id}`),

  // 自定义曲谱
  CUSTOM_SONG_SEARCH: (params) =>
    http.post("/customSong/platformSearch", params),
  CUSTOM_SONG_DETAIL: (songId) =>
    http.get(`/customSong/platformDetail?songId=${songId}`),
  CUSTOM_SONG_PUBLISH: (songId) =>
    http.post(`/customSong/publish?songId=${songId}`),
  CUSTOM_SONG_UN_PUBLISH: (songId, unPublishStatus) =>
    http.post(
      `/customSong/unPublish?songId=${songId}&unPublishStatus=${unPublishStatus}`
    ),
  CUSTOM_SONG_DELETE: (userId, songId) =>
    http.post(`/customSong/delete?userId=${userId}&songId=${songId}`),
  CUSTOM_SONG_InsertOrUpdate: (params) =>
    http.post("/customSong/insertOrUpdate", params), //自定义曲谱新增/编辑

  SET_CUSTOM_PUBLISH_TIME: (data) =>
    http.post("/customSong/setRegularPublish", data), // 设置马甲曲谱定时发布时间

  // 修改曲谱-fake收藏量
  UPDATE_FAKE_COLLECTION: (params) =>
    http.get(
      `/customSong/setFakeMark?songId=${params.songId}&fakeMark=${params.fakeMark}`
    ),

  // 修改歌单-fake 收藏量
  UPDATE_SHEET_FAKE_COLLECTION: (params) =>
    http.post(
      `/sheet/setFakeMark?puserId=${params.puserId}&sheetId=${params.sheetId}&fakeMark=${params.fakeMark}`
    ),

  // 提示tip
  TIP_SEARCH: (params) => http.post("/tip/platformSearch", params),
  TIP_PUBLISH: (id, pUserId) =>
    http.post(`/tip/publish?id=${id}&pUserId=${pUserId}`),
  TIP_OFFSHELF: (id, pUserId) =>
    http.post(`/tip/offShelf?id=${id}&pUserId=${pUserId}`),
  TIP_DELETE: (id) => http.post(`/tip/delete?id=${id}`),
  TIP_INSERTORUPDATE: (params) => http.post("/tip/insertOrUpdate", params),

  NO_SEARCH_KEYS: (type) => http.get(`/noSearch/getKeys?type=${type}`),
  NO_SEARCH_BOARD: (type, key) =>
    http.get(`/noSearch/board?type=${type}&key=${key}`),

  // 用户收藏夹
  USER_COLLECTION_SEARCH: (params) =>
    //  原接口---- `/sheet/getByUserId?userId=${params.userId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`
    http.get(`/sheet/getByUserId?userId=${params.userId}`),
  USER_COLLECTION_SONG_BYID: (params) =>
    http.get(
      `/sheet/getSong?sheetId=${params.sheetId}&start=${params.start}&top=${params.top}`
    ),
  // 渠道-安卓列表
  ANDROID_CHANNEL_LIST: (params) => http.get("/version/allChannel", { params }),

  // 2.6.0歌单管理
  /**
   * 歌单系列
   *
   * */
  /**
   * 歌单本身
   */
  SHEET_SEARCH_LIST: (params) => http.post("/sheet/search", params), //搜索歌单
  SHEET_INSERT: (data) => http.post("/sheet/insert", data), //新增歌单
  SHEET_UPDATE: (data) => http.post("/sheet/update", data), //更新歌单
  SHEET_PUBLISH: (data) =>
    http.post(`/sheet/publish?sheetId=${data.sheetId}&puserId=${data.puserId}`), //歌单-上架
  SHEET_UNPUBLISH: (data) =>
    http.post(`/sheet/unPublish?sheetId=${data.sheetId}&puserId=${data.puserId}&unPublishStatus
=${data.unPublishStatus}`), //歌单-下架
  SHEET_DELETE: (data) =>
    http.post(`/sheet/delete?sheetId=${data.sheetId}&puserId=${data.puserId}`), //删除歌单

  SHEET_ADD_SONG: (data) => http.post("/sheet/addSong", data), // 添加曲谱到歌单
  SHEET_SET_SORTS: (data) => http.post("/sheet/sortSong", data), //歌单-内部曲谱排序
  SHEET_GET_SONG: (params) =>
    http.get(
      `/sheet/getSong?sheetId=${params.sheetId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`
    ), //获取歌单内曲谱
  SHEET_REMOVE_SONG: (data) => http.post("/sheet/removeSong", data), //歌单-移除内部曲谱

  SHEET_SEARCH_SONG: (data) => http.post("/song/platformSearchV2", data), //歌单管理-搜索官方曲谱
  SHEET_SEARCH_CUSTOM_SONG: (data) =>
    http.post("/customSong/platformSearchV2", data), //歌单管理-搜索自定义曲谱

  /** 歌单精选 */
  SHEET_CHOICE_SEARCH_LIST: (data) => http.post("/sheetChoice/search", data), //搜索歌单精选
  SHEET_CHOICE_DISABLE: (data) =>
    http.post(`/sheetChoice/disable?id=${data.id}&puserId=${data.puserId}`), // 精选失效
  SHEET_CHOICE_INSERT: (data) => http.post("/sheetChoice/insert", data), // 新增增选
  SHEET_CHOICE_UPDATE: (data) => http.post("/sheetChoice/update", data), // 修改增选

  /** 歌单广场 */
  SHEET_SQUARE_SEARCH_LIST: (data) => http.post("/sheetSquare/search", data), //搜索歌单广场
  SHEET_SQUARE_UNLOCK: (data) =>
    http.post(`/sheetSquare/unlockSort?id=${data.id}&puserId=${data.puserId}`), //解锁排序
  SHEET_SQUARE_LOCK: (data) => http.post("/sheetSquare/lockSort", data), //锁定排序
  SHEET_SQUARE_SET_SORT: (data) =>
    http.post(
      `/sheetSquare/setSort?id=${data.id}&sort=${data.sort}&puserId=${data.puserId}`
    ), //设定排序值-单个
  /**
   * 批量处理标签
   */
  checkBatchExcel: (data) => http.post("/customSong/check", data),
  editBatchExcel: (data) => http.post("/customSong/batchEditDeal", data),

  /***
   * 2.6.5 运营标识管理
   */
  getOperationTagList: (data) => http.post("/operationsTag/search", data), // 标识列表
  publishOperationTag: (data) =>
    http.post("/operationsTag/updatePublish", data), // 修改生效状态
  deleteOperationTag: (data) => http.post("/operationsTag/delete", data), // 删除运营标识
  getOperateTaglist: () => http.get("/operationsTag/list"), // 全部运营标识
  addOrUpdateOperationTag: (data) =>
    http.post("/operationsTag/addOrUpdate", data), // 新增或更新运营标识

  /**
   * 2.7.0 社区后台一期
   */
  getSongVideoList: (params) => http.get("/songVideo/searchList", { params }),
  updateSongVideo: (data) => http.post("/songVideo/update", data),
  publishSongVideo: (data) => http.post("/songVideo/publish", data),
  unPublishSongVideo: (data) => http.post("/songVideo/unPublish", data),
  deleteSongVideo: (data) => http.post("/songVideo/del", data),

  /**
   * 2.7.3 c2升级固件
   */
  /** 模块 */
  getNewestModulesList: (data) =>
    http.post(`/versionDeviceItem/device/getNewestItem?model=${data.model}`), //获取模块以及升级小项 列表
  createModuleItem: (data) =>
    http.post("/versionDeviceItemMeta/device/createMeta", data), //创建模块
  updateModuleItem: (data) =>
    http.post(
      `/versionDeviceItemMeta/updateMeta?metaId=${data.metaId}&remark=${data.remark}`
    ), //修改模块
  getC2DeviceDetails: (data) =>
    http.post(`/versionDevice/c2/detail?id=${data.id}`), // 获取c2版本详情
  /**模块对应小项 */
  createDeviceItem: (formData, params) =>
    http.post(`/versionDeviceItem/device/createDeviceItem`, formData, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }), // 创建设备升级小项
  updateDevieItem: (data) =>
    http.post("/versionDeviceItem/updateDeviceItem", data), //修改升级小项

  getNewestVersionItem: (params) =>
    http.get("/versionDevice/getNewestVersion", { params }), //获取上次ota对应app版本

  /** 获取客户端版本--不需要用 */
  //   getVersionAppList: () => http.post("/versionDeviceItemMeta/getVersionApp"), //获取模块以及升级小项 列表
  /** c2相关接口 */
  insertOrUpdateNewSong: (data) =>
    http.post("/customSong/song2/insertOrUpdate", data),
  parseMidi: (data) => http.post(`/customSong/parseMid`, data), // 解析midi文件
  //   strict=1
  parseQQMIDISong: (data) => http.post("/customSong/parseQQSong", data), // 解析QQ音乐文件

  /** 2.7.8  c2节奏型、音色*/
  publishPick: (data) => http.post(`/rhythmic/pick/publish?pickId=${data}`), // 发布拨片节奏型
  unPublishPick: (data) => http.post(`/rhythmic/pick/offShelf?pickId=${data}`), // 下架拨片节奏型
  deletePick: (data) => http.post(`/rhythmic/pick/delete?pickId=${data}`), // 删除拨片节奏型
  getPickList: (data) => http.post("/rhythmic/pick/platformSearch", data), // 拨片节奏型列表
  updatePickItem: (data) => http.post("/rhythmic/pick/insertOrUpdate", data), // 更新节奏型列表

  publishDrum: (data) => http.post(`/rhythmic/drum/publish?drumId=${data}`), // 发布鼓机节奏型
  unPublishDrum: (data) => http.post(`/rhythmic/drum/offShelf?drumId=${data}`), // 下架鼓机节奏型
  deleteDrum: (data) => http.post(`/rhythmic/drum/delete?drumId=${data}`), // 删除鼓机节奏型
  getDrumList: (data) => http.post("/rhythmic/drum/platformSearch", data), // 鼓机节奏型列表
  updateDrumItem: (data) => http.post("/rhythmic/drum/insertOrUpdate", data), // 更新鼓机节奏型

  publishSoundCard: (data) =>
    http.post(`/rhythmic/note/publish?noteId=${data}`), // 发布音色卡
  unPublishSoundCard: (data) =>
    http.post(`/rhythmic/note/offShelf?noteId=${data}`), // 下架音色卡
  deleteSoundCard: (data) => http.post(`/rhythmic/note/delete?noteId=${data}`), // 删除音色卡
  getSoundCardList: (data) => http.post("/rhythmic/note/platformSearch", data), // 音色卡列表
  updateSoundCardItem: (data) =>
    http.post("/rhythmic/note/insertOrUpdate", data), // 更新音色卡

  getAssetsCategoryTreeList: (data) =>
    http.post("/assetCategory/getTree", data), // 音色卡分类列表
  getAssetsCategoryTreeDataList: (data) =>
    http.post("/assetCategory/getTreeData", data), // 音色卡  原数据列表

  addAssetCategory: (data) => http.post("/assetCategory/add", data), // 新增资产分类
  updateAssetCategory: (data) => http.post("/assetCategory/update", data), // 修改资产分类
  deleteAssetCategory: (data) =>
    http.post(`/assetCategory/delete?id=${data.id}`), // 删除资产分类
  getTimbreList: (data) =>
    http.post("/rhythmic/timbreCard/platformSearch", data), //音色卡列表

  getAllSecondCategoryList: (params) =>
    http.get("/assetCategory/querySecondCategory", params), //获取资产二级分类筛选框 列表

  getSysCommonSettingList: (data) =>
    http.post("/sysCommonSetting/platformSearch", data), // 通用配置列表
  updateCommonSetting: (data) =>
    http.post("/sysCommonSetting/insertOrUpdate", data), //更新通用配置

  getCommonSettingDetail: (id) =>
    http.get(`/sysCommonSetting/detail?id=${id}`), //获取通用配置详情

  publishCommonSetting: (data) =>
    http.post(`/sysCommonSetting/publish?id=${data}`), //发布通用配置
  unPublishCommonSetting: (data) =>
    http.post(`/sysCommonSetting/unPublish?id=${data}`), //下架通用配置
  deleteCommonSetting: (data) =>
    http.post(`/sysCommonSetting/delete?id=${data}`), //删除通用配置

  getVersionTimbrecardList: (data) =>
    http.post("/versionTimbrecard/platformSearch", data), // 音色卡固件列表
  publishVersionTimbrecard: (data) =>
    http.post(`/versionTimbrecard/publish?id=${data}`), // 发布音色卡固件
  unPublishVersionTimbrecard: (data) =>
    http.post(`/versionTimbrecard/unPublish?id=${data}`), // 下架音色卡固件
  deleteVersionTimbrecard: (data) =>
    http.post(`/versionTimbrecard/delete?id=${data}`), // 删除音色卡固件
  updateVersionTimbrecard: (data) =>
    http.post("/versionTimbrecard/insertOrUpdate", data), //更新音色卡固件

  getNewestTimbreCardList: (data) =>
    http.post(
      `/versionDeviceItem/timbrecard/getNewestItem?cardCode=${data.cardCode}`
    ), //获取音色卡模块以及升级小项 列表
  createTimbreCardItem: (data) =>
    http.post("/versionDeviceItemMeta/timbrecard/createMeta", data), //创建音色卡模块
  getTimbreCardDetail: (data) =>
    http.post(`/versionTimbrecard/detail?id=${data.id}`), //获取音色卡固件详情
  updateVersionTimbrecard: (data) =>
    http.post("/versionTimbrecard/insertOrUpdate", data), //修改 音色卡固件

  createTimbrecardDeviceItem: (formData, params) =>
    http.post(`/versionDeviceItem/timbrecard/createDeviceItem`, formData, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }), // 创建音色卡 设备升级小项
  createSoundCard: (params) =>
    http.post("/rhythmic/timbreCard/insertOrUpdate", params), // 创建声音卡
  /** c2相关接口 */
  insertOrUpdateNewSong: (data) =>
    http.post("/customSong/song2/insertOrUpdate", data),
  parseMidi: (data) => http.post(`/customSong/parseMid`, data), // 解析midi文件
  //   strict=1
  parseQQMIDISong: (data) => http.post("/customSong/parseQQSong", data), // 解析QQ音乐文件

  /**
   * 2.8.0 精选视频管理
   */
  // 查询精选视频列表
  getSelectedVideoList: (params) =>
    http.get("/videoChoice/searchList", { params }),
  // 新增精选（只需传视频ID）
  addToSelected: (data) => http.post("/videoChoice/addChoice", data),
  // 删除精选（只需传视频ID）
  removeFromSelected: (data) => http.post("/videoChoice/delChoice", data),
  // 新增置顶（只需传视频ID）
  setVideoTop: (data) => http.post("/videoChoice/addTop", data),
  // 删除置顶（只需传视频ID）
  cancelVideoTop: (data) => http.post("/videoChoice/delTop", data),

  // 复制多维曲谱副本
  copySongMetasong: (data) =>
    http.post(`/customSong/copyCustomSong?songId=${data.songId}`),

  getBlueToothEffectList: (data) => http.post("/eq/platformSearch", data), // 蓝牙音效列表
  publishBlueToothEffect: (data) => http.post(`/eq/publish?id=${data.id}`), // 发布蓝牙音效
  unPublishBlueToothEffect: (data) => http.post(`/eq/unPublish?id=${data.id}`), // 下架蓝牙音效
  deleteBlueToothEffect: (data) => http.post(`/eq/delete?id=${data.id}`), //删除蓝牙音效
  updateBlueToothEffect: (data) => http.post("/eq/insertOrUpdate", data), //更新蓝牙音效
  setEffectFakeUseCount: (data) =>
    http.post(
      `/eq/setFakeUseCount?id=${data.id}&fakeUseCount=${data.fakeUseCount}`,
      data
    ), // 设置音效fake使用次数
  // 查看设备型号（全部
  getDeviceModel: (params) => http.get("/device/getDeviceModel", params),

  // 3.1.5  恢复midi文件
  recoverMIDIFile: (params, config = {}) =>
    http.post(
      `/customSong/recoverMidi?songId=${params.songId}&type=${params.type}`,
      null,
      {
        responseType: "blob",
        ...config,
      }
    ),
  // 麦克风Eq新增或修改
  updateMicEffect: (data) => http.post("/eq/micEq/insertOrUpdate", data),
};
